// extracted by mini-css-extract-plugin
module.exports = {"GoToTopNavigation":"GoToTopNavigation__2S5BO","isHidden":"isHidden__2S5BO","GoToTopNavigation_text":"GoToTopNavigation_text__2S5BO"};